//@ts-ignore
import Flights2B from "./Flights2B";

export default Flights2B;
